import styled from 'styled-components'

export const Section = styled.section`
  ${props =>
    props.isFullWidth &&
    `
    width: 100%;
    max-width: none;
    padding-right: 0;

  `}

  // Override bolt styling for headings in the ATT drawer
  h2 {
    font-size: var(--ds-font-size-display-1);
  }

  h3 {
    font-size: var(--ds-font-size-body-2);
  }
`
